import { render } from "./ToolbarItem.vue?vue&type=template&id=006824f0&ts=true"
import script from "./ToolbarItem.vue?vue&type=script&lang=ts"
export * from "./ToolbarItem.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./ToolbarItem.vue?vue&type=style&index=0&id=006824f0&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__